import React from 'react';
import styles from './PromoItem.module.sass';

export function PromoItem(props) {
    return (
        <li className={styles.promo__item} key={props.listItem}>
            {props.children}<span className={styles.check}>{props.listItem}</span>
        </li>);
}